module.exports = __webpack_public_path__ + "static/media/04_digginglight.9ba957bd.jpg";